module.exports = __webpack_public_path__ + "img/logo-2.fc21b1e5.svg";